module.exports = __webpack_public_path__ + "img/activities2.988ced68.svg";